import React from "react";
import Grid from "@mui/material/Grid2";
import TagsTable from "./TagsTable";

function Tags() {
  return (
    <>
      <Grid size={12}>
        <TagsTable />
      </Grid>
    </>
  );
}

export default Tags;
